var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.enabled)?_c('div',{ref:"root",staticClass:"patsnap-copilot"},[_c(_setup.WujieVue,_vm._b({},'WujieVue',_setup.getOptions(),false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }